 const customLocaleText = {
  columnMenuUnsort: "Sin clasificar",
  columnMenuSortAsc: "Ordenar en orden ascendente",
  columnMenuSortDesc: "Ordenar en orden descendente",
  columnMenuFilter: "Filtrar",
  columnMenuHideColumn: "Ocultar columna",
  columnMenuShowColumns: "Mostrar columnas"
};

  export default customLocaleText;